export default "__VITE_ASSET__DDbLy97l__"